import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ErrorMessages } from "src/app/shared/common/errormessages";
import { validationmethod } from "src/app/shared/common/validationmethod";
import { CommonService } from "src/app/shared/services/common.service";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { UsersService } from 'src/app/shared/services/users.service';
import { FormFieldsTrimAndClean } from "src/app/shared/common/trim-clean-Data";
import { MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss'],
    standalone: false
})
export class ProfileComponent implements OnInit {

  profileFields = { 'userID': "", 'userName': "", 'firstName': "", 'lastName': "", 'phoneNumber': "", 'empNo': "", 'colorSchemeID': "", "photo": "", "photoPath": "" };

  validationMessages;

  formGroup: UntypedFormGroup;

  colorSchemeData: any = [];

  userDetailsData: any = [];

  imgpre: string;

  backgroundColorButton = "";

  constructor(private errorMessages: ErrorMessages, private validation: validationmethod, private commonService: CommonService, private spinner: NgxUiLoaderService, private localStorageSettings: LocalStorageSettingsService, private usersService: UsersService, private formFieldsTrimer: FormFieldsTrimAndClean, private dialogRef: MatDialogRef<ProfileComponent>, private snackBar: MatSnackBar) {

    //Messages for validations.
    this.validationMessages = this.errorMessages.profileMessages;

  }

  async ngOnInit() {

    this.formValidations();

    await this.retrieveUserDetails();

    await this.retrieveColorScheme();

    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");

    console.log(this.backgroundColorButton);

  }

  formValidations() {

    //Form validations.
    this.formGroup = new UntypedFormGroup({
      firstName: new UntypedFormControl(""),
      lastName: new UntypedFormControl(""),
      phoneNumber: new UntypedFormControl("", [Validators.required, this.validation.noWhitespaceValidator, Validators.maxLength(15)]),
      empNo: new UntypedFormControl("")
    });

  }

  async retrieveColorScheme() {

    this.spinner.start();

    this.colorSchemeData = await this.commonService.retrieveService("colorScheme", 0, 0);

    let getColorSchemeID: number = this.userDetailsData[0].colorschemeid;

    console.log(getColorSchemeID);

    this.colorSchemeData.filter(colorSchemeDataTemporary => {

      if (getColorSchemeID == colorSchemeDataTemporary.colorschemeid) {

        console.log(colorSchemeDataTemporary.colorschemeid);

        colorSchemeDataTemporary["isColorSchemeIDBoolean"] = true;

      }

      else {

        colorSchemeDataTemporary["isColorSchemeIDBoolean"] = false;

      }

    });

    console.log(this.colorSchemeData);

    this.spinner.stop();

  }

  async retrieveUserDetails() {

    this.spinner.start();

    //Getting the username from localStorage.
    let userName = this.localStorageSettings.getSettings("AuthUsername");

    console.log(userName);

    this.userDetailsData = await this.commonService.retrieveSingleRecordService("users", "username", userName);

    console.log(this.userDetailsData);

    this.profileFields.userID = this.userDetailsData[0].userid;

    this.profileFields.userName = this.userDetailsData[0].username;

    this.profileFields.firstName = this.userDetailsData[0].firstname;

    this.profileFields.lastName = this.userDetailsData[0].lastname;

    this.profileFields.phoneNumber = this.userDetailsData[0].phonenumber;

    this.profileFields.empNo = this.userDetailsData[0].empno;

    this.profileFields.colorSchemeID = this.userDetailsData[0].colorschemeid;

    this.profileFields.photo = this.userDetailsData[0].photo;

    this.profileFields.photoPath = this.userDetailsData[0].photopath;

    this.imgpre = this.userDetailsData[0].photopath;

    this.spinner.stop();

  }

  async updateUserRecord() {

    console.log(this.colorSchemeData);

    let updateObject: any = {};

    updateObject["userID"] = this.profileFields.userID;

    updateObject["phoneNumber"] = this.profileFields.phoneNumber;

    updateObject["colorSchemeID"] = this.profileFields.colorSchemeID;

    updateObject["photo"] = this.profileFields.photo;

    updateObject["photoPath"] = this.profileFields.photoPath;

    console.log(updateObject);

    if (this.formGroup.valid) {

      this.formFieldsTrimer.trimFormfieldsData(updateObject);

      let updateServiceResponse = await this.usersService.updateService(updateObject);

      if (updateServiceResponse.error == false) {

        await this.reset();

      }

    }

    else {

      this.validation.validateAllFormFields(this.formGroup);

      this.validation.getvalidationmessage();

    }

  }

  async reset() {

    let empty = { 'userID': "", 'userName': "", 'firstName': "", 'lastName': "", 'phoneNumber': "", 'empNo': "", 'colorSchemeID': "", "photo": "", "photoPath": "" };

    this.profileFields = empty;

    this.formGroup.reset();

    this.formValidations();

    //Getting the username from localStorage.
    let userName = this.localStorageSettings.getSettings("AuthUsername");

    let userData: any = await this.commonService.retrieveSingleRecordService("users", "username", userName);

    console.log(userData[0]);

    console.log(userData[0].colorschemeid);

    let colorSchemeData: any = await this.commonService.retrieveSingleRecordService("colorscheme", "colorschemeid", userData[0].colorschemeid);

    console.log(colorSchemeData);

    this.localStorageSettings.saveSettings("ColorA", colorSchemeData[0].colora);

    this.localStorageSettings.saveSettings("ColorB", colorSchemeData[0].colorb);

    this.localStorageSettings.saveSettings("ColorC", colorSchemeData[0].colorc);

    this.localStorageSettings.saveSettings("ColorD", colorSchemeData[0].colord);

    this.dialogRef.close();

  }

  changeColorSchemeID(colorSchemeID) {

    console.log(colorSchemeID);

    this.profileFields.colorSchemeID = colorSchemeID;

  }

  // event on input type file
  uploadProfilePic(input): void {
    this.readThispassport(input.target)
  }

  readThispassport(inputValue: any): void {
    var file: File = inputValue.files[0];
    var FileS: File = inputValue.files[0];
    if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg') {

      console.log(file.size / 1000)
      var size = file.size / 1000
      if (size <= 3072) {
        var fileName = FileS.name;
        //var filename = (<HTMLInputElement>document.getElementById('file-id')).value;

        var passport: FileReader = new FileReader();
        passport.onloadend = (e) => {
          var image = passport.result;
          console.log(passport.result)
          var passportbase64result = passport.result.toString().split(',', 2)[1];

          // this is to check the file is empty or not
          if (passportbase64result == null) {
            this.snackBar.open(this.errorMessages.validAttachement, "OK", {
              duration: 5000,
            });
          } else {
            this.imgpre = passport.result.toString();
            this.profileFields.photoPath = passportbase64result;
            this.profileFields.photo = fileName;
          }
        }
        passport.readAsDataURL(file);
      } else {
        this.snackBar.open("Selected image " + file.name + ", size should be less than 3MB", "OK", {
          duration: 5000,
        });
        //(<HTMLInputElement>document.getElementById('passportPhotoName'));
      }
    } else {
      this.snackBar.open(file.name + " is a invalid image type ", "OK", {
        duration: 5000,
      });
      //(<HTMLInputElement>document.getElementById('passportPhotoName')).value = null;
    }
  }

}